import React, { useEffect, useState } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import BookingsLldRow from './BookingsLldRow';
import { Typography, withStyles } from '@material-ui/core';
import Loader from '../Layout/Loader';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Tooltip from '@material-ui/core/Tooltip';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import TableHead from '@material-ui/core/TableHead';
import KobooTablePagination from '../Layout/KobooTablePagination';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { longLocationTypeMultiplicator } from '../../constants/LongLocationType';

const columnData = [
  {
    id: 'renter_name', numeric: false, disablePadding: false, label: 'Loueur',
  },
  {
    id: 'id', numeric: true, disablePadding: false, label: 'N° Réservation',
  },
  {
    id: 'username', numeric: false, disablePadding: false, label: 'Client',
  },
  {
    id: 'date', numeric: true, disablePadding: false, label: 'Date de récupération du vélo',
  },
  {
    id: 'location_duration', numeric: true, disablePadding: false, label: 'Durée de la location',
  },
  {
    id: 'is_electric', numeric: false, disablePadding: false, label: 'Type de vélo',
  },
  {
    id: 'start_inventory', numeric: false, disablePadding: false, label: 'Etat des lieux début',
    disableSorting: true
  },
];

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(3),
    overflowX: 'auto',
  },
  table: {
    minWidth: 700,
  },
});

const objectsToTableData = (objects) => {
  return objects.map(obj => {
      return {
        id: obj.id,
        renter_name: obj.renter_name,
        username: obj.username,
        date: obj.date,
        lldCount: obj.lldCount,
        lldType: obj.lldType,
        is_electric: obj.is_electric,
        start_inventory: obj.start_inventory,
        original: obj,
      };
    },
  );
};

const BookingsLldTable = (props) => {
  const { booksLld, pending, openDialog, classes, authUser, error } = props;
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('date');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    setTableData(objectsToTableData(props.booksLld));
    sortTableData();
  }, [booksLld]);

  const sortTableData = () => {
    tableData.sort((firstEl, secondEl) => {
      let prop1, prop2;
      if (orderBy === 'location_duration') {
        prop1 = firstEl.lldCount * longLocationTypeMultiplicator[firstEl.lldType];
        prop2 = secondEl.lldCount * longLocationTypeMultiplicator[secondEl.lldType];
      } else {
        prop1 = firstEl[orderBy];
        prop2 = secondEl[orderBy];
      }
      if (prop1 < prop2) {
        return -1;
      } else if (prop1 > prop2) {
        return 1;
      }
      return 0;
    });
    if (order === 'desc') {
      tableData.reverse();
    }
  };

  const handleChangeOrder = property => {
    const newOrderBy = property;
    let newOrder = 'asc';
    if (orderBy === newOrderBy && order === newOrder) {
      newOrder = 'desc';
    }
    setOrder(newOrder);
    setOrderBy(newOrderBy);
  };

  const handleChangePage = (event, page) => {
    event.stopPropagation();
    setPage(page);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(event.target.value);
  };

  if (!pending && booksLld && booksLld.length > 0) {
    sortTableData();
  }


    return (
      <React.Fragment>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              {columnData.map(column => (
                <TableCell
                  key={column.id}
                  padding={column.disablePadding ? 'none' : 'normal'}
                  sortDirection={orderBy === column.id ? order : false}
                >
                  {!column.disableSorting && <Tooltip
                    title="Trier"
                    placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                    enterDelay={300}>
                    <TableSortLabel
                      active={orderBy === column.id}
                      direction={order}
                      onClick={() => handleChangeOrder(column.id)}>
                      {column.label}
                    </TableSortLabel>
                  </Tooltip>}
                  {column.disableSorting
                  && <Typography variant={'body2'} style={{fontWeight: 500}}>
                    {column.label}
                  </Typography>}
                </TableCell>
              ), this)}
              <TableCell padding="checkbox">
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {pending && <tr>
              <td colSpan={columnData.length}>
                <Loader />
              </td>
            </tr>}
            {!pending && booksLld && booksLld.length > 0 &&
            tableData.slice(
              page * rowsPerPage,
              (page * rowsPerPage) + rowsPerPage,
            ).map(bookLld => (
              <BookingsLldRow
                key={bookLld.id}
                bookLld={bookLld}
                openDialog={openDialog}
                error={error}
                authUser={authUser}
              />
            ))}
            {!pending && booksLld && booksLld.length <= 0
            && <tr>
              <td colSpan={columnData.length}>
                <Typography style={{ textAlign: "center"}} variant="subtitle1">Aucune réservation</Typography>
              </td>
            </tr>
            }
          </TableBody>
        </Table>
        <KobooTablePagination
          numberOfItems={booksLld.length}
          rowsPerPage={rowsPerPage}
          label="Réservations par page"
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </React.Fragment>
    );
};

function mapStateToProps(state) {
  return {
    authUser: state.users.authUser,
    error: state.booksLld.error,
  };
}

export default compose(
  connect(mapStateToProps),
  withStyles(styles),
)(BookingsLldTable);



// WEBPACK FOOTER //
// ./src/components/BookingsLld/BookingsLldTable.jsx